<template>
	<div>
		<div class="reportDesk_content_header">
			<div class="reportDesk_content_header_l">
				<div class='reportDesk_content_header_l_date' @click='handleCilck_month'>
					<span class="pic">
						<img src="/static/v12houtai/calendar.png"  alt="">
					</span>
					<span class="mouth">{{nowMonth}}月份</span>
					<span  class="clickImg" ><img src="/static/v12houtai/monthClick.png" alt=""></span>
				</div>
				
				<p class="down">{{maxPeriod_text}}</p>
			</div>
			<div class="reportDesk_content_header_r">
				<p class="up">*当前显示为近期已结账月份，您还可以查看正在统计的月份</p>
					<p class='member'>
						<el-tooltip effect="dark" placement="bottom">
							<div slot='content'>
								<ul>
									<li v-for='item in member_info' :key='item.name'>
										{{item.name}}：{{item.number}}（{{item.limit}}）
									</li>
								</ul>
							</div>
							<div style='display: inline-block;'>
								<span><img src="/static/v12houtai/member.png" alt="成员"></span>
								<span>共 {{member_num}} 人</span>
							</div>
						 </el-tooltip>
					</p>
			</div>
		</div>
		<div class="reportDesk_content_container">
			<!-- 左边模块 -->
			<div class='reportDesk_content_left'>
				<div class='left_content'>
					<div class='left_title'>
						<span style='font-size: 0.3rem;'>经营状况 </span><span style='font-size: .12rem; margin-left: .1rem'>({{newYearPeriod}})</span>
					</div>
					<div class='left_content1'>
						<div class="Proportion_szzb">
							<span>收支占比</span>
						</div>
						<div class='left_content1_container'>
							<div id='echart_left_YVP' ref='echart_left_YVP'></div>
							<div class='Proportion_total'>
								<div class='Proportion_total_item'>
									<div class='Proportion_total_item_t'>
										<span class='Dot' ></span>
										<div class='listTitle'>总收入</div>
									</div>
									<div class='Proportion_total_item_m' id='zsr_ss'>
										<div class='white_space'>
											<span>¥ </span><span ref='totalBalance_m2' :data-time="time" >0</span>  万
										</div>
									</div>
								</div>
								<div class='Proportion_total_item'>
									<div class='Proportion_total_item_t'>
										<span class='Dot'></span>
										<div class='listTitle'>总支出</div>
									</div>
									<div class='Proportion_total_item_m'>
										<div class='white_space'>
											<span>¥ </span><span ref='totalBalance_m1' :data-time="time" >0</span> 万
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class='left_content1_container1'>
							<div class='profit_and_loss'>
								<div class="Proportion_szzb" >
									<span>收支盈亏状况</span>
								</div>
								<div id='Proportion_SZYK'>
										
								</div>
								<div class='Proportion_SZYKs'>
									<span class='Proportion_SZYKs_top'>
										<span v-if='isprofit'>盈利</span>
										<span v-if='!isprofit'>亏损</span>
										<i class='el-icon-upload2 red' v-if='isprofit'></i>
										<i class='el-icon-download green' v-if='!isprofit'></i>
									</span>
									<span class='Proportion_SZYKs_bottom'>
										{{profits}}万
									</span>
								</div>
							</div>
							<div clss='trend'>
								<div class="Proportion_szzb">
									<span>收支趋势</span>
								</div>
								<div id='Proportion_SZQS'></div>
							</div>
						</div>
					</div>
					<div class='left_content2'>
						<div class='cost_structure'>
							<div class='cost_structure_header_title'>
								<div style='padding-left: .3rem'>费用结构图</div>
								<div style="color: #8FBEFF;font-size: .12rem;padding-right: .3rem">单位（元）</div>
							</div>
							<div class='cost_structure_content'>
								<div id='cost_structure_echart'></div>
								<!-- <div class='cost_structure_total'>
									<div class='cost_structure_total_item' v-for='item in costStatisticsData'>
										<span>{{item.name}}</span>
										<span :class="item.type==1?'num1':item.type==2?'num2':'num3'">{{item.value}}</span>
									</div>
								</div> -->
							</div>
						</div>
						<div class='tax_statistics'>
							<div class='tax_statistics_header'>
								<div class='tax_statistics_header_title'>
									<span style='font-size: .18rem;font-weight: bold;'>税务统计</span>
									<span style='font-size: .12rem;margin-left: 10px;'>({{yearPeriod.slice(0,4)}}.1 - {{yearPeriod.slice(0,4)}}.12)</span>
								</div>
								<div class='tax_statistics_header_nav'>
									<ul>
										<li v-for='item in swList' :key='item.id' :class='nowTab==item.id?"active_sw":""' @click='handleTax_statistics(item)'>{{item.name}}</li>
									</ul>
								</div>
							</div>
							<div class='tax_statistics_echart'>
								<div class='item_data'>
									<span class='item_data_left'>￥{{taxRateAndTotaly.zzs}}</span>
								</div>
								<div style='margin-top: .3rem;'>
									<div  class='tax_statistics_echart_item' v-for='item in taxStatisticsList' @click='handleCilck_swtj(item)'>
										<div class='p_container' :style='item.type?"cursor:pointer":""'>
											<el-tooltip class="item" effect="dark" placement="right-start">
												<div slot='content'>
													<p style='margin-bottom:.1rem'>￥{{item.money}}</p>
													<div v-if='item.growth!==""'>
														<p>相比去年：</p>
														<span style="margin-top: .1rem;display: inline-block;">
															{{item.growth*100}}%
															<i class='el-icon-bottom' style='color:red;font-weight: bold;' v-if='item.growth<0'></i>
															<i class='el-icon-top' style='color:green;font-weight: bold;' v-else></i>
														</span>
													</div>
												</div>
												<p
													:class='item.isSumZero?"disabledZero":item.nowTab?"selection":item.type?"normal":"disabled"' :style='{height:item.height}' 
												></p>
											</el-tooltip>
										</div>
										<span :class='item.nowTab?"selection1":item.type?"normal1":"disabled1"'>
											{{item.month}}
											
										</span>
									</div>
								</div>
							

							</div>
						</div>
						
					</div>
					<div class='left_title'>
						<span style='font-size: 0.3rem;'>资产负债</span><span style='font-size: 12px;margin-left: .15rem;'>({{newYearPeriod}})</span>
					</div>
					<div  class='left_content3'>
						<div class='left_content3_total'>
							<div class="total_assets">
								<div class="total_assets_item">
									<div class="total_assets_item_top">
										<span class='Dot'></span>
										<span class="total_assets_text">总资产</span>
									</div>
									<div class="total_assets_item_bottom">
										{{assetsTotal.zc}} 万
									</div>
								</div>
								<div class='seal' v-if='!assetsTotal.blance'>
									<img src="/static/v12houtai/bupingheng.png" alt="不平衡">
								</div>
							</div>
							<div class="liabilities">
								<div class="liabilities_item">
									<div class="liabilities_item_text">
										负债
									</div>
									<div class="liabilities_item_num">
										{{assetsTotal.fz}} 万
									</div>
								</div>
								<div class="liabilities_item">
									<div class="liabilities_item_text">
										所有者权益
									</div>
									<div class="liabilities_item_num">
										{{assetsTotal.syz}} 万
									</div>
								</div>
							</div>
						</div>
						<div class="echart_zzqst_container">
							<div class="echart_zzqst_title">
								增长趋势图
							</div>
							<div id='echart_zzqst'></div>
						</div>
						
					</div>
					<div class='left_content4'>
						<div class='left_content4_item1'>
							<div class='item_title'>
								<div class='item_title_left'>
									总资产 TOP 5
								</div>
								<div class='item_title_right'>
									单位（万元）
								</div>
							</div>
							<div class='item_content'>
								<div class='item_content_item' v-for='item in top5_zzcInfo'>
									<div class="item_content_item_content">
										<div :id='item.styleID'></div>
										<div class="item_content_item_text">{{item.name}}</div>
									</div>
									<div class="item_content_item_money">
										{{item.money}}
									</div>
								</div>
								<!-- <div class='item_content_item'>
									<div class="item_content_item_content">
										<div id='item_content_item_echart1'></div>
										<div class="item_content_item_text">原材料</div>
									</div>
									<div class="item_content_item_money">
										46万
									</div>
								</div>
								<div class='item_content_item'>
									<div class="item_content_item_content">
										<div id='item_content_item_echart2'></div>
										<div class="item_content_item_text">其他的其他</div>
									</div>
									<div class="item_content_item_money">
										46万
									</div>
								</div>
								<div class='item_content_item'>
									<div class="item_content_item_content">
										<div id='item_content_item_echart3'></div>
										<div class="item_content_item_text">存款</div>
									</div>
									<div class="item_content_item_money">
										46万
									</div>
								</div>
								<div class='item_content_item'>
									<div class="item_content_item_content">
										<div id='item_content_item_echart4'></div>
										<div class="item_content_item_text">其他</div>
									</div>
									<div class="item_content_item_money">
										46万
									</div>
								</div> -->
							</div>
						</div>
						<div class='left_content4_item2'>
							<div class='item_title'>
								<div class='item_title_left'>
									负债 TOP 5
								</div>
								<div class='item_title_right'>
									单位（万元）
								</div>
							</div>
							<div class="item_content">
								<div id='item_content_echart_bar'></div>
								<div class="item_content_money">
									<div class="item_content_item_money" v-for='item in debtTOP_money'>
										{{item.money}}
									</div>
								</div>
							</div>
						</div>
						<div class='left_content4_item3'>
							<div class='item_title'>
								<div class='item_title_left'>
									所有权益者占比
								</div>
								<div class='item_title_right'>
									单位（万元）
								</div>
							</div>
							<div class='item_content'>
								<div id='left_content4_item3_pinEchart'>
									
								</div>
								<div>
									
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<!-- 右边模块 -->
			<div class='reportDesk_content_right'>
				<div class='right_content'>
					<div class='right_title'>
						<span style='font-size: 0.3rem;'>资金总览</span>
					</div>
					<div class='right_content1'>
						<div class='right_content1_container'>
							<div @click='handleCilck_jcz("0")' class='totalBalance_container'>
								<span class='totalBalance' >总余额</span>
								<div>
									<span class='totalBalance_m' ref='totalBalance_m' :data-time="time" >0</span>
									<span class='totalBalance_m'>万</span>
								</div>
							</div>
							<div class='accounts_container'>
								<div class='account_advance' @click='handleCilck_jcz("1")'>
									<div class="container_s">
										<span class='account_advance_icon'>
											<img src="/static/v12houtai/jinzhang.png" alt="进账">
										</span>
									    <span class='account_advance_text'>进账</span>
									</div>
									
									<div class='account_advance_money'>
										{{moneyList_inCome.money}} 万
									</div>
								</div>
								<div class='out_of_account'  @click='handleCilck_jcz("2")'>
									<div class="container_s">
										<span class='out_of_account_icon'>
											<img src="/static/v12houtai/chuzhang.png" alt="出账">
										</span>
									    <span class='out_of_account_text'>出账</span>
									</div>
									
									<div class='out_of_account_money'>
										{{moneyList_out.money}} 万
									</div>
								</div>
							</div>
							<div class='public_line'></div>
							<div class='type_title'>
								<span>类型</span>
								<span>金额（元）</span>
							</div>
							<div class='type_item' v-for='item in overviewOfFundsType' @click='handleCilckTypeList(item)'>
								<div class='type_item_title'>
									<div class='type_item_title_left'>
										<span class='type_item_title_icon'>
											<img :src="'/static/v12houtai/'+item.icon+'.png'">
										</span>
										<span class='type_item_title_name'>{{item.name}}</span>
									</div>
									<div class='type_item_title_right'>{{item.money}}</div>
								</div>
								<div class='public_line' v-if='item.icon!="otherCash"'></div>
							</div>
						</div>
					</div>
					<div class='right_title'>
						<span style='font-size: 0.3rem;'>往来单位</span>
					</div>
					<div class='right_content2'>
						<div class='right_content2_item' v-for='item in reciprocatingUnitList' >
							<div class='right_content2_item_title'>
								<span class='right_content2_item_icon'>
									<img :src="'/static/v12houtai/'+item.icon+'.png'" >
								</span>
								<span class='right_content2_item_title_text'>{{item.name}}</span>
							</div>
							<ul class='type_item_list'>
								<li v-for='i in item.child' :key='i.id' :class='i.id==nowTypeID1?"active":""' @click='handleCilckTypeList1(i)'>
									<span>{{i.name}}</span>
									<span>{{i.money}}</span>
								</li>
							</ul>
							<div class='public_line' v-if='item.icon!="otherContacts"'></div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<zj-dialog :showVisible.sync='dialogVisible' :nowTypeID='nowTypeID' :nowTypeID_money='nowTypeID_money' :period_date_start='period_date_start' :period_date_end='period_date_end'></zj-dialog>
		<wldw-dialog :showVisibles.sync='dialogVisibles' :nowTypeID1='nowTypeID1' :period_date_start='period_date_start' :period_date_end='period_date_end'
					 :disabled_zl='disabled_zl'
		></wldw-dialog>
		<month-type :m_showVisible.sync='m_dialogVisible' @yearPeriod_m='yearPeriod_m'></month-type>
	</div>

</template>
<script>
	import echarts from 'echarts'
	import ZjDialog from '@/components/dialog/ZjDialog'
	import WldwDialog from '@/components/dialog/WldwDialog'
	import monthType from '@/components/dialog/monthType'
	import {currencys} from '@/assets/utils/currencyFormat'
	export default {
		props: {
			 time: {
			   type: Number,
			   default: 1
			  },
			super_messages:Boolean
		},
		components: {
			WldwDialog,
			ZjDialog,
			monthType
		},
		data() {
			return {
				nowTypeID_money: null, // 进出账总余额点击
				style_p:{
					height:'118px',
				},
				dialogVisible:false,
				dialogVisibles: false,
				m_dialogVisible: false,  // 月份弹框
				swList: [
					{name: '增值税', id: '1'},
					{name: '所得税', id: '2'},
				],
				nowTab: '1',       // 当前ID
				nowTypeID: '', // 现金当前选中
				nowTypeID1: '', // 往来单位当前选中
				yearPeriod: '',       // 当前期
				moneyList_out: 0,	// 资金总览总余额、进出账
				moneyList_inCome: 0,// 资金总览总余额、进出账
				moneyList_total: 0, // 资金总览总余额、进出账
				overviewOfFundsType:[], // 资金总览类型
				
				reciprocatingUnitList: [],   //  往来单位
				taxStatisticsList: [],  // 税务统计
				top5_zzcInfo:[],     // 总资产top5
				assetsTotal: {},     // 总资产负债数据
				debtTOP_money: [],    // 负债 TOP 5金额
				assetsTotalLineData: {}, // 资产负债折线图
				equityTOP:[],  	// 所有者权益占比
				taxRateAndTotaly:{},  // 税务统计柱子点击数据
				costStatisticsData: [],    // 费用结构图数据
				profit: '',        // 盈利
				profits: '',        // 盈利
				balanceOfPaymentsList: [],  // 收支占比
				pointerValue: 50,      // 收支占比指针位置
				member_num: 0,       // 成员数量
				member_info:[], // 成员详情
				nowMonth: null,    // 现在月份
				maxPeriod_text: '统计中...', // 最大月份统计
				newYearPeriod: '',    // 当前期格式化
				period_date_start:null,      // 当前期时间戳 开始
				period_date_end:null,      // 当前期时间戳 结束
				isprofit: null,          // 是否盈利
				disabled_zl: false,  // 是否不禁用账龄
			}
		},
		
		created() {
			this.getMaxPeriodInfo();
		},
		mounted() {
			
				
		},
		methods: {
			// 初始化
			init() {
				this.overviewOfFunds_money();
				this.overviewOfFunds_type();
				this.getReciprocatingUnitList();
				this.getTaxStatistics();
				this.getAssetLoadInfo();
				this.getAssetsTotalLineData(); // 资产负债折线图
				this.getCostStatisticsInfo(); // 费用结构图
				this.getOutAndIncomeData();   // 总支出、总收入
				this.getBalanceOfPaymentsInfo();  // 收支占比
				this.getInAndOutTrendsInfo();    // 收支趋势
				this.getAccountInfoInfo();
			},
			// 货币格式化
			formatMoney(money){
				let num;
				if(Number(money)) {
					return num = (Number(money)/10000).toFixed(2);
				}else {
					return money;
				}
			},
			//  传入期数获取当月的开始和结尾
			getDateMonth(date) {
				date = date.toString();
				date = date.slice(0,4)+"/"+ date.slice(4);
				let month,nextMonth,oneDay;
				this.period_date_start = new Date(date).getTime();
				if(Number(date.slice(-2))===12){
					nextMonth = Number(date.slice(0,4))+1+'/01'
				}else {
					month = (Number(date.slice(5))+1)>=10? (Number(date.slice(5))+1):("0"+(Number(date.slice(5))+1))
					nextMonth = Number(date.slice(0,4))+"/"+ month;
				}
				oneDay = 1000*60*60*24;
				this.period_date_end = new Date(nextMonth).getTime()-oneDay;
			},
			// 获取最大月份显示和期数/
			async getMaxPeriodInfo() {
				let _=this;
				let number;
				try {
					_.$emit('super_messages_back',false);
					_.$http.post('Experience/getMaxPeriod',{}).then(res=>{
						if(res&&res.data.code==1) {
							_.maxPeriod_text = res.data.data.max;
							_.$emit('companyName',res.data.data.name)
							_.yearPeriod = res.data.data.yearPeriod.toString();
							_.getDateMonth(_.yearPeriod);
							number = _.yearPeriod.substring(_.yearPeriod.length-2);
							_.newYearPeriod = _.yearPeriod.slice(0,4)+"."+ _.yearPeriod.slice(4);
							if(Number(number)<10) {
								this.nowMonth = number.substring(number.length-1);
							}else {
								this.nowMonth = number;
							}
							this.init();

						}
					})
				}catch(e) {

				}
			},
			// 接收子组件点击月份传过来的期数
			yearPeriod_m(val) {
				
				this.yearPeriod = val;
				this.getDateMonth(val);
				let number = val.substring(val.length-2);
				this.newYearPeriod = val.slice(0,4)+"."+ val.slice(4);
				if(Number(number)<10) {
					this.nowMonth = number.substring(number.length-1);
				}else {
					this.nowMonth = number;
				}
				this.init();
			},
			// 月份点击效果
			handleCilck_month() {
				this.m_dialogVisible = true;
			},
			// 获取收支趋势占比图数据/
			getInAndOutTrendsInfo() {
				let _=this;
				try {
					_.$http.post('Experience/inAndOutTrends',{period:_.yearPeriod}).then(res=>{
						if(res&&res.data.code==1) {
							_.getEcharts_szqs(res.data.data);
						}
					})
				}catch(e) {

				}
			},
			// 获取账套人员信息/
			getAccountInfoInfo() {
				let _=this;
				try {
					_.$http.post('Experience/getAccountInfo',{}).then(res=>{
						if(res&&res.data.code==1) {
							_.member_info = res.data.data.info;
							_.member_num = res.data.data.member;
						}
					})
				}catch(e) {

				}
			},

			// 获取收支占比数据/
			getBalanceOfPaymentsInfo() {
				let _=this;
				try {
					_.$http.post('Experience/balanceOfPayments',{period:_.yearPeriod}).then(res=>{
						if(res&&res.data.code==1) {
							_.balanceOfPaymentsList = res.data.data;
							if(_.balanceOfPaymentsList.length){
								_.balanceOfPaymentsList.forEach(i=>{
									if(i.money<0) {
										i.money = 0;
									}
								})
							}
							// 右边百分比计算
							if(_.balanceOfPaymentsList[4].money) {
								_.balanceOfPaymentsList[0].percentage = (_.balanceOfPaymentsList[0].money/_.balanceOfPaymentsList[4].money*100).toFixed(0);
								_.balanceOfPaymentsList[1].percentage = (_.balanceOfPaymentsList[1].money/_.balanceOfPaymentsList[4].money*100).toFixed(0);
								_.balanceOfPaymentsList[2].percentage = (_.balanceOfPaymentsList[2].money/_.balanceOfPaymentsList[4].money*100).toFixed(0);
								_.balanceOfPaymentsList[3].percentage = (_.balanceOfPaymentsList[3].money/_.balanceOfPaymentsList[4].money*100).toFixed(0);
							}else {
								_.balanceOfPaymentsList[0].percentage = 0;
								_.balanceOfPaymentsList[1].percentage =0;
								_.balanceOfPaymentsList[2].percentage = 0;
								_.balanceOfPaymentsList[3].percentage = 0;
							}
							

							// 左边百分比计算
							if(_.balanceOfPaymentsList[9].money) {
								_.balanceOfPaymentsList[5].percentage = (_.balanceOfPaymentsList[5].money/_.balanceOfPaymentsList[9].money*100).toFixed(0);
								_.balanceOfPaymentsList[6].percentage = (_.balanceOfPaymentsList[6].money/_.balanceOfPaymentsList[9].money*100).toFixed(0);
								_.balanceOfPaymentsList[7].percentage = (_.balanceOfPaymentsList[7].money/_.balanceOfPaymentsList[9].money*100).toFixed(0);
								_.balanceOfPaymentsList[8].percentage = (_.balanceOfPaymentsList[8].money/_.balanceOfPaymentsList[9].money*100).toFixed(0);
							}else {
								_.balanceOfPaymentsList[5].percentage = 0;
								_.balanceOfPaymentsList[6].percentage = 0;
								_.balanceOfPaymentsList[7].percentage =0;
								_.balanceOfPaymentsList[8].percentage = 0;
							}
							

							if(_.balanceOfPaymentsList[4].money-_.balanceOfPaymentsList[9].money>0) {
								_.pointerValue = 25;
							}else if(_.balanceOfPaymentsList[4].money-_.balanceOfPaymentsList[9].money<0) {
								_.pointerValue = 75;
							}else {
								_.pointerValue = 50;
							}


							_.getEcharts_szzb(_.balanceOfPaymentsList);
							_.getEcharts_szyk();
						}
					})
				}catch(e) {

				}
			},

			// 获取费用结构图数据POST /Experience/costStatistics
			getCostStatisticsInfo() {
				let _=this;
				try {
					_.$http.post('Experience/costStatisticsLine',{period:_.yearPeriod}).then(res=>{
						if(res&&res.data.code==1) {
							// let sum=0,copyList;
							// _.costStatisticsData = res.data.data;
							// copyList = JSON.parse(JSON.stringify(res.data.data));
							// if(res.data.data.length){
							// 	copyList.forEach(item=>{
							// 		item.value?Number(item.value).toFixed(2):0;
							// 		sum+=item.value;
							// 	})
							// 	copyList.forEach(i=>{
							// 		i.percent = sum?( i.value/sum*100).toFixed(0) + "%":"0%";
							// 	})
							// 	_.costStatisticsData.forEach(i=>{
							// 		i.value = currencys(i.value);
							// 	})
							// }
							_.$nextTick(()=>{
								_.getEcharts_fyjg(res.data.data);
							})
						}
					})
				}catch(e) {

				}
			},
			// 获取总收入、总支出
			getOutAndIncomeData() {
				let _=this;
				try {
					_.$http.post('Experience/OutAndIncome',{period:_.yearPeriod}).then(res=>{
						if(res&&res.data.code==1) {
							_.outAndIncomeData = res.data.data;
							if((Number(res.data.data.income) - Number(res.data.data.out))>=0) {
								_.$set(_,'isprofit',true);
								_.profit = (Number(res.data.data.income) - Number(res.data.data.out)).toFixed(2);
							}else {
								_.$set(_,'isprofit',false);
								_.profit = (Number(res.data.data.out) - Number(res.data.data.income)).toFixed(2);
							}

							_.profits = _.profit?currencys(_.profit/10000):currencys(0);
							_.profit = _.profit?currencys(_.profit):currencys(0);
							// 总支出总收入数字滚动特效
							if(res.data.data.out) {
								_.numberGrow(_.$refs.totalBalance_m1,res.data.data.out);
							}else {
								_.$refs.totalBalance_m1.innerHTML = currencys(0);
							}
							if(res.data.data.income) {
								_.numberGrow(_.$refs.totalBalance_m2,res.data.data.income);
							}else {
								_.$refs.totalBalance_m2.innerHTML = currencys(0);
							}
						}
					})
				}catch(e) {

				}
			},

			// 获取资产负债所有的数据
			getAssetLoadInfo() {
				let _=this;
				try {
					_.$http.post('AssetsLiability/allAsset',{period:_.yearPeriod}).then(res=>{
						if(res&&res.data.code==1) {

							// 总资产TOP5
							this.top5_zzcInfo = res.data.data.assetTOP.map((item,index)=>{
			 					item.styleID = "item_content_item_echart"+index;
			 					item.money = currencys(item.money/10000);
			 					return item;
			 				})

			 				// 总资产钱钱数据
			 				this.assetsTotal = res.data.data.assetsTotal;
			 				this.assetsTotal.zc = currencys(this.assetsTotal.zc/10000);
			 				this.assetsTotal.syz = currencys(this.assetsTotal.syz/10000);
			 				this.assetsTotal.fz = currencys(this.assetsTotal.fz/10000);

			 				// 负债TOP5
			 				this.debtTOP = res.data.data.debtTOP;
			 				this.debtTOP_money = res.data.data.debtTOP.money.map(i=>{
			 					i.money = currencys(i.money/10000);
			 					return i;
			 				});
			 				// 所有者权益占比
			 				this.equityTOP = res.data.data.equityTOP;
							this.$nextTick(()=>{
								_.getEcharts_zzc1(this.top5_zzcInfo[0]);
								_.getEcharts_zzc2(this.top5_zzcInfo[1]);
								_.getEcharts_zzc3(this.top5_zzcInfo[2]);
								_.getEcharts_zzc4(this.top5_zzcInfo[3]);
								_.getEcharts_zzc5(this.top5_zzcInfo[4]);
								_.getEcharts_fz();
								_.getEcharts_qyzb();
							})
						}
					})
				}catch(e) {

				}
			},
			// 资产负债折线图
			getAssetsTotalLineData() {
				let _=this;
				try {
					// const loading = this.$loading({
				 //          lock: false,
				 //          text: '正在初始化，请稍后...',
				 //          spinner: 'el-icon-loading',
				 //          background: 'rgba(0, 0, 0, .7)',
				 //        });
					_.$http.post('AssetsLiability/assetsTotalLine',{period:_.yearPeriod}).then(res=>{
						if(res&&res.data.code==1) {
							//loading.close();
							_.assetsTotalLineData = res.data.data;
							_.$nextTick(()=>{
								_.getEcharts_zzqst();
							})
						}
					})
				}catch(e) {
					//loading.close();
				}
			},
			// 进出账点击效果
			handleCilck_jcz(type) {
				let _ = this;
				this.nowTypeID='';
				if(type==1) {
					_.dialogVisible = true;
					_.nowTypeID_money = _.moneyList_inCome.type;
				}else if(type==0) {
					_.dialogVisible = true;
					_.nowTypeID_money = _.moneyList_total.type;
				}else {
					_.dialogVisible = true;
					_.nowTypeID_money = _.moneyList_out.type;
				}
			},
			// 税务统计点击效果
			handleCilck_swtj(row) {
				if(row.type) {
					if(row.isSumZero) {
						return;
					}
					this.taxStatisticsList.forEach(item=>{
						item.nowTab=false;
					})
					row.nowTab = true;
					this.taxRateAndTotaly.zzs = row.money;
					//this.getCilck_swtjData(row.yearPeriod,this.nowTab);
				}else {
					return;
				}
			},
			// 税务统计柱子点击请求接口
			// getCilck_swtjData(period,type) {
			// 	let _=this;
			// 	try {
			// 		_.$http.post('Experience/taxRateAndTotaly',{period:period , type:type}).then(res=>{
			// 			if(res&&res.data.code==1) {
			// 				this.taxRateAndTotaly = res.data.data;
			// 				this.taxRateAndTotaly.zzs = currencys(this.taxRateAndTotaly.zzs);
							
			// 				this.taxRateAndTotaly.taxRate = this.taxRateAndTotaly.taxRate?(this.taxRateAndTotaly.taxRate*100).toFixed(2):0;
			// 			}
			// 		})
			// 	}catch(e) {

			// 	}
			// },
			// 税务统计切换
			handleTax_statistics(item) {
				this.nowTab = item.id;

				this.getTaxStatistics();
			},
			// 税务统计
			getTaxStatistics() {
				let _=this;
				try {
					_.$http.post('Experience/statisticsOfTax',{period:_.yearPeriod , type:this.nowTab}).then(res=>{
						if(res&&res.data.code==1) {
							let sumMoney = 0; 
							this.taxStatisticsList = res.data.data.map((item)=>{
								item.nowTab = false;
								sumMoney +=item.money;
								return item;
							});
							let nowTabList = this.taxStatisticsList.filter((item)=>{
								return item.type == true;
							})
							nowTabList[nowTabList.length-1].nowTab = true;
							this.taxRateAndTotaly.zzs = currencys(nowTabList[nowTabList.length-1].money);
							// this.getCilck_swtjData(nowTabList[nowTabList.length-1].yearPeriod,this.nowTab)
							this.taxStatisticsList.forEach(item=>{

								if(item.type) {
									if(sumMoney){
										if(item.money) {
											if((item.money/sumMoney)*100<2) {
												item.height = '2%';
											}else {
												item.height = (item.money/sumMoney)*100+'%';
											}
											item.isSumZero = false;
											item.money=currencys(item.money);
										}else {
											item.height = "1px";
											item.isSumZero = false;
											item.money=currencys(item.money);
										}
										
									}else {
										item.height = "1px";
										item.isSumZero = false;
										item.money=currencys(item.money);
									}
								}else {
									item.height = '1px';
									item.isSumZero = true;
									item.money=currencys(item.money);
								}	
							})


						}
					})
				}catch(e) {

				}
			},
			// 往来单位
			getReciprocatingUnitList() {
				let _=this;
				try {
					_.$http.post('AccountCurrent/account',{period:_.yearPeriod}).then(res=>{
						if(res&&res.data.code==1) {
							_.reciprocatingUnitList = res.data.data;
							if(_.reciprocatingUnitList.length){
								_.reciprocatingUnitList.forEach(i=>{
									i.child.forEach(ii=>{
										ii.money = currencys(ii.money)
									})
								})
								
							}
							_.nowTypeID1 = res.data.data[0].child.length?res.data.data[0].child[0].id:res.data.data[1].child.length?res.data.data[1].child[0].id:res.data.data[2].child.length?res.data.data[2].child[0].id:'';
						}
					})
				}catch(e) {

				}
			},
			// 获取资金总览数据:进出账、总余额
			overviewOfFunds_money() {
				let _=this;
				try {
					_.$http.post('MoneyOverview/InComeAndOut',{period:_.yearPeriod}).then(res=>{
						if(res&&res.data.code==1) {
							_.moneyList_out = res.data.data[0].out;
							_.moneyList_inCome = res.data.data[0].inCome;
							_.moneyList_inCome.money = currencys(res.data.data[0].inCome.money/10000);
							_.moneyList_out.money = currencys(res.data.data[0].out.money/10000);
							_.moneyList_total = res.data.data[0].total;
							if(_.moneyList_total.money) {
								_.numberGrow(_.$refs.totalBalance_m,_.moneyList_total.money);
							}else {
								_.$refs.totalBalance_m.innerHTML =  currencys(0);
							}
						}
					})
				}catch(e) {

				}
			},
			// 获取资金总览数据:类型
			overviewOfFunds_type() {
				let _=this;
				try {
					_.$http.post('MoneyOverview/subDetail',{period:_.yearPeriod}).then(res=>{
						if(res&&res.data.code==1) {
							_.overviewOfFundsType = res.data.data;
							if(_.overviewOfFundsType.length) {
								_.overviewOfFundsType.forEach(i=>{
									i.money = currencys(i.money);
								})
							}
						}
					})
				}catch(e) {

				}
			},
			// 现金点击
			handleCilckTypeList(row) {
				this.nowTypeID_money = null;
				this.nowTypeID = row.id;
				this.dialogVisible = true;
			},
			// 现金点击
			handleCilckTypeList1(row) {
				if(row.name == '应收' || row.name == '其他应收') {
					this.disabled_zl = true;
				}else {
					this.disabled_zl = false;
				}
				this.nowTypeID1 = row.id;
				this.dialogVisibles = true;
			},
			// 随机颜色
			randColor() {
				let r = Math.floor( Math.random() * 256 );
				let g = Math.floor( Math.random() * 256 );    
				let b = Math.floor( Math.random() * 256 );
				return "rgb("+r+','+g+','+b+")";
			},
			// 所有权益者占比
			getEcharts_qyzb() {
				let _ = this,bossName=[],defaultName,defaultData,color=['#FFB232','#0C92FD','#21E4BF'];
				if(this.equityTOP.equity.length) {
					if(this.equityTOP.equity.length===1) {
						this.equityTOP.equity.push({
									name:'--',
									value: 0
								},{
									name:'---',
									value: 0
								})
					}
				    if(this.equityTOP.equity.length===2) {
						this.equityTOP.equity.push({
									name:'---',
									value: 0
								})
					}
					this.equityTOP.equity.forEach(i=>{
						if(bossName.length<3) {
							bossName.push(i.name);
						}
					})
					let number_xh = this.equityTOP.equity.length;
					for(var j=0;j<number_xh-3;j++) {
						color.push(this.randColor());
					}
				}
				defaultName = ["-","--","---"];
				defaultData = [{
					name:'-',
					value: 0
				},{
					name:'--',
					value: 0
				},{
					name:'---',
					value: 0
				}]
				let myChart = echarts.init(document.getElementById('left_content4_item3_pinEchart'));
				let option = {
					color:color,
				    tooltip : {
				        trigger: 'item',
				        formatter: function(val) {
				        	return val.name+" : "+ currencys(val.value) + "   （" + val.percent + "%" + "）";
				        }
				    },
				    legend: [{
	    				        orient: 'vertical',
	    				        x: 'left',
	    				        y: '70%',
	    				        textStyle: {color: '#fff'},
	    				        data:bossName.length?bossName:defaultName,
	    				        formatter:function(name){
	    				        	let oa = option.series[0].data;
	    				        	for(var i = 0; i < option.series[0].data.length; i++){
	    			                    if(name==oa[i].name){
	    									return name ;
	    			                    }
	    				        	}
	    				        }
	    				    },{
	    				        orient: 'vertical',
	    				        x: 'right',
	    				        y: '70%',
	    				        icon:'none',
	    				        textStyle: {color: '#fff'},
	    				        data: bossName.length?bossName:defaultName,
	    				        formatter:function(name){
	    				        	var oa = option.series[0].data;
	    				        	let num;
	    				        	if(oa.length) {
	    				        		oa.forEach(i=>{
	    				        			num+=i.value;
	    				        		})
	    				        	}
	    				        	for(var i = 0; i < option.series[0].data.length; i++){
	    			                    if(name==oa[i].name){
	    									if(num==0){
	    										return 0
	    									}else{
	    										return currencys(oa[i].value/10000);
	    									}
	    			                    }
	    				        	}
	    				        }
	    				    }],
				    series : [
				        {
				            name: '所有权益者占比',
				            type: 'pie',
				            radius : '55%',
				            center: ['50%', '35%'],
				            data:this.equityTOP.equity.length?this.equityTOP.equity:defaultData,
				            itemStyle: {
				                emphasis: {
				                    shadowBlur: 10,
				                    shadowOffsetX: 0,
				                    shadowColor: 'rgba(0, 0, 0, 0.5)'
				                }
				            },
				            itemStyle: {
				                normal: {
				                    label:{ 
			                            show: false, 
			//	                            position:'inside',
			                            formatter: '{b} : {c} ({d}%)' 
			                        }
				                },
			                    labelLine :{show:true}
				            }
				        }
				    ]
				};
				 myChart.setOption(option);
				window.onresize=function(){
				      myChart.resize();
				 }

			},
			// 负债top5
			getEcharts_fz() {
				let myChart = echarts.init(document.getElementById('item_content_echart_bar'));
				// 本月已经完成/目标
			    let baifenbi = this.debtTOP.duty.reverse();
			    let gs = this.debtTOP.name.reverse();
			    let myColor = ['#20BD90', '#2E87FF'];
			    let myColorBg = ['#334055'];
			  	let option = {
			        backgroundColor: '#243145',
			      grid: {
			        left: '2%',
			        right: '2%',
			        bottom: '0%',
			        top: '0%',
			        containLabel: false
			      },
			      xAxis: [{
			          show: false,
			        },
			        {
			          show: false,
			        }
			      ],
			      yAxis: {
			        type: 'category',
			        show: false
			      },
			      series: [
			        //背景色 完成、总金额
			        {
			          show: true,
			          type: 'bar',
			          barGap: '-100%',
			          barWidth: 13,
			          z: 1,
			          itemStyle: {
			            normal: {
			              color: function(params) {
			                var num = myColorBg.length;
			                return myColorBg[params.dataIndex % num]
			              }
			            }
			          },
			          data: [1, 1,1,1,1],
			        },
			        //亮色条 百分比
			        {
			          show: true,
			          type: 'bar',
			          barGap: '-100%',
			          barWidth: 13,
			          z: 2,
			          itemStyle: {
			            normal: {
			              color: function(params) {
			                var num = myColor.length;
			                return myColor[params.dataIndex % num]
			              }
			            }
			          },
			          // label: {
			          //   normal: {
			          //     show: true,
			          //     textStyle: {
			          //       color: '#fff',
			          //     },
			          //     position: 'inside',
			          //     formatter: function(data) {
			          //       return (baifenbi[data.dataIndex] * 100).toFixed(1) + '%';
			          //     }
			          //   }
			          // },
			          data: baifenbi,
			        },
			        //公司名称
			        {
			          show: true,
			          type: 'bar',
			          xAxisIndex: 1, //代表使用第二个X轴刻度
			          barGap: '-100%',
			          barWidth: '10%',
			          itemStyle: {
			            normal: {
			              barBorderRadius: 200,
			              color: 'transparent'
			            }
			          },
			          label: {
			            normal: {
			              show: true,
			              position: [0, '-20'],
			              textStyle: {
			                color: '#969EAC',
			              },
			              formatter: function(data) {
			                return gs[data.dataIndex];
			              }
			            }
			          },
			          data: [1, 1,1,1,1]
			        }
			      ]
			    };
				 myChart.setOption(option);
				window.onresize=function(){
				      myChart.resize();
				 }
			},
			// 总资产echart图形
			getEcharts_zzc1(pie) {
				console.log(pie.pie)
				let myChart = echarts.init(document.getElementById('item_content_item_echart0'));
				let data = pie.pie;
				let color = ['#24404d', '#20BD90'];
				let data1 = data[0].value + data[1].value;
				let baseData = [];
				for (var i = 0; i < data.length; i++) {
				    baseData.push({
				        value: data[i].value,
				        name: data[i].name,
				        itemStyle: {
				            normal: {
				                borderWidth: 2,
				                shadowBlur: 4.5,
				                borderColor: color[i],
				                shadowColor: '#243145'
				            }
				        }
				    });
				}
				let option = {
				    
				    backgroundColor: '#243145',
				    color: color,
				    center:["50%","50%"],
				    series: [{
				            zlevel: 1,
				            name: '数据采集',
				            type: 'pie',
				            radius: [15, 17],
				            startAngle: '135',
				            hoverAnimation: false,
				            label: {
				                normal: {
				                    show: false,
				                    formatter: ['{c|{c}}', '{b|{b}}'].join('\n'),
				                    rich: {
				                        b: {
				                            fontSize: 1.6,
				                            lineHeight: 3
				                        }

				                    }
				                }
				            },
				            itemStyle: {
				                normal: {
				                    shadowColor: 'rgba(0, 0, 0, 0.8)',
				                    shadowBlur: 5,
				                }
				            },
				            data: baseData
				        },
				    ]
				};
				 myChart.setOption(option);
				window.onresize=function(){
				      myChart.resize();
				 }
			},
			getEcharts_zzc2(pie) {
				let myChart = echarts.init(document.getElementById('item_content_item_echart1'));
				let data = pie.pie;
				let color = ['#243a59', '#268AFF'];
				let data1 = data[0].value + data[1].value;
				let baseData = [];
				for (var i = 0; i < data.length; i++) {
				    baseData.push({
				        value: data[i].value,
				        name: data[i].name,
				        itemStyle: {
				            normal: {
				                borderWidth: 2,
				                shadowBlur: 4.5,
				                borderColor: color[i],
				                shadowColor: '#243145'
				            }
				        }
				    });
				}
				let option = {
				     center:["50%","50%"],
				    backgroundColor: '#243145',
				    color: color,
				    series: [{
				            zlevel: 1,
				            name: '数据采集',
				            type: 'pie',
				            radius: [15, 17],
				            startAngle: '135',
				            hoverAnimation: false,
				            label: {
				                normal: {
				                    show: false,
				                    formatter: ['{c|{c}}', '{b|{b}}'].join('\n'),
				                    rich: {
				                        b: {
				                            fontSize: 1.6,
				                            lineHeight: 3
				                        }

				                    }
				                }
				            },
				            itemStyle: {
				                normal: {
				                    shadowColor: 'rgba(0, 0, 0, 0.8)',
				                    shadowBlur: 5,
				                }
				            },
				            data: baseData
				        },
				    ]
				};
				 myChart.setOption(option);
				window.onresize=function(){
				      myChart.resize();
				 }
			},
			getEcharts_zzc3(pie) {
				let myChart = echarts.init(document.getElementById('item_content_item_echart2'));
				let data = pie.pie;
				let color = ['#3c344a', '#FE5578'];
				let data1 = data[0].value + data[1].value;
				let baseData = [];
				for (var i = 0; i < data.length; i++) {
				    baseData.push({
				        value: data[i].value,
				        name: data[i].name,
				        itemStyle: {
				            normal: {
				                borderWidth: 2,
				                shadowBlur: 4.5,
				                borderColor: color[i],
				                shadowColor: '#243145'
				            }
				        }
				    });
				}
				let option = {
				     center:["50%","50%"],
				    backgroundColor: '#243145',
				    color: color,
				    series: [{
				            zlevel: 1,
				            name: '数据采集',
				            type: 'pie',
				            radius: [15, 17],
				            startAngle: '135',
				            hoverAnimation: false,
				            label: {
				                normal: {
				                    show: false,
				                    formatter: ['{c|{c}}', '{b|{b}}'].join('\n'),
				                    rich: {
				                        b: {
				                            fontSize: 1.6,
				                            lineHeight: 3
				                        }

				                    }
				                }
				            },
				            itemStyle: {
				                normal: {
				                    shadowColor: 'rgba(0, 0, 0, 0.8)',
				                    shadowBlur: 5,
				                }
				            },
				            data: baseData
				        },
				    ]
				};
				 myChart.setOption(option);
				window.onresize=function(){
				      myChart.resize();
				 }
			},
			getEcharts_zzc4(pie) {
				let myChart = echarts.init(document.getElementById('item_content_item_echart3'));
				let data = pie.pie;
				let color = ['#2c3556', '#6C5CE7'];
				let data1 = data[0].value + data[1].value;
				let baseData = [];
				for (var i = 0; i < data.length; i++) {
				    baseData.push({
				        value: data[i].value,
				        name: data[i].name,
				        itemStyle: {
				            normal: {
				                borderWidth: 2,
				                shadowBlur: 4.5,
				                borderColor: color[i],
				                shadowColor: '#243145'
				            }
				        }
				    });
				}
				let option = {
				     center:["50%","50%"],
				    backgroundColor: '#243145',
				    color: color,
				    series: [{
				            zlevel: 1,
				            name: '数据采集',
				            type: 'pie',
				            radius: [15, 17],
				            startAngle: '135',
				            hoverAnimation: false,
				            label: {
				                normal: {
				                    show: false,
				                    formatter: ['{c|{c}}', '{b|{b}}'].join('\n'),
				                    rich: {
				                        b: {
				                            fontSize: 1.6,
				                            lineHeight: 3
				                        }

				                    }
				                }
				            },
				            itemStyle: {
				                normal: {
				                    shadowColor: 'rgba(0, 0, 0, 0.8)',
				                    shadowBlur: 5,
				                }
				            },
				            data: baseData
				        },
				    ]
				};
				 myChart.setOption(option);
				window.onresize=function(){
				      myChart.resize();
				 }
			},
			getEcharts_zzc5(pie) {
				let myChart = echarts.init(document.getElementById('item_content_item_echart4'));
				let data = pie.pie;
				let color = ['#3c4147', '#FECA57'];
				let data1 = data[0].value + data[1].value;
				let baseData = [];
				for (var i = 0; i < data.length; i++) {
				    baseData.push({
				        value: data[i].value,
				        name: data[i].name,
				        itemStyle: {
				            normal: {
				                borderWidth: 2,
				                shadowBlur: 4.5,
				                borderColor: color[i],
				                shadowColor: '#243145'
				            }
				        }
				    });
				}
				let option = {
				     center:["50%","50%"],
				    backgroundColor: '#243145',
				    color: color,
				    series: [{
				            zlevel: 1,
				            name: '数据采集',
				            type: 'pie',
				            radius: [15, 17],
				            startAngle: '135',
				            hoverAnimation: false,
				            label: {
				                normal: {
				                    show: false,
				                    formatter: ['{c|{c}}', '{b|{b}}'].join('\n'),
				                    rich: {
				                        b: {
				                            fontSize: 1.6,
				                            lineHeight: 3
				                        }

				                    }
				                }
				            },
				            itemStyle: {
				                normal: {
				                    shadowColor: 'rgba(0, 0, 0, 0.8)',
				                    shadowBlur: 5,
				                }
				            },
				            data: baseData
				        },
				    ]
				};
				 myChart.setOption(option);
				window.onresize=function(){
				      myChart.resize();
				 }
			},
			//  总资产echart图形结束..................................................................///////////////////////////////
			// 费用结构图
			getEcharts_fyjg(data) {
				let arr1 = data.cwfy.money;
				let arr2 = data.glfy.money;
				let arr3 = data.xsfy.money;

				let month = data.month;
				let myChart = echarts.init(document.getElementById('cost_structure_echart'));
				let fontColor = '#30eee9';
				let daveData1,daveData2,daveData3,dot1,dot2,dot3;
				if(arr1.length) {
					daveData1 = arr1.filter(i=>{
						return i || i==0
					})
				}
				if(arr2.length) {
					daveData2 = arr2.filter(i=>{
						return i || i==0
					})
				}
				if(arr3.length) {
					daveData3 = arr3.filter(i=>{

						return i || i==0
					})
				}
				dot1 = daveData1.length==1?8:0.01;
				dot2 = daveData2.length==1?8:0.01;
				dot3 = daveData3.length==1?8:0.01;

				let option ={
				        backgroundColor:'#243145',
						grid: {
					        left: '5%',
				            right: '5%',
				            top:'20%',
					        bottom: '10%',
					        containLabel: true
						},
						 tooltip: {
					         trigger: 'axis',
					         formatter:function(params) {
							    return '<p style="color:#969EAC;font-size:12px">' + params[0].seriesName +"："+ '</p>'+'<p style="color:#0092f6;font-size:14px;font-weight:bold;">' + (params[0].value==null?"-":currencys(params[0].value)) + '</p>'+ '<p style="color:#969EAC;font-size:12px;margin-top:12px;">' + params[1].seriesName + "："+'</p>'+'<p style="color:#00d4c7;font-size:14px;font-weight:bold;">' +  (params[1].value==null?"-":currencys(params[1].value))  + '</p>'+ '<p style="color:#969EAC;font-size:12px;margin-top:12px;">' + params[2].seriesName + "："+ '</p>'+'<p style="color:#aecb56;font-size:14px;font-weight:bold;">' +  (params[2].value==null?"-":currencys(params[2].value))  + '</p>'

							},
					         
					     },
						legend: {
							show:true,
							x:'center',
							y:'5%',
							icon: 'stack',
							itemWidth:10,
							itemHeight:10,
							textStyle:{
								color:'#1bb4f6'
							},
							data:['销售费用','管理费用','财务费用']
						},
						xAxis : [
					        {
					            type : 'category',
					            boundaryGap : false,
					            axisLabel:{
					            	color:'#8A96A0'
					            },
					            axisLine:{
				               		show:true,
				               		lineStyle:{
						            	color:'#8A96A0',
						            	opacity:.2
						            }
								},
								axisTick:{
					            	show:false,
					            },  
					            splitLine:{
					            	show:false,
						            lineStyle:{
						            	color:'#195384'
						            }
						        },
					            data : month
					        }
					    ],
					    yAxis : {
								type : 'value',
								name : '',
								show:false,
								splitNumber:3,
								axisLabel : {
									formatter: '{value}',
									textStyle:{
										color:'#8A96A0'
									}
								},
								axisLine:{
									show:false,
									lineStyle:{
										color:'#27b4c2'
									}
								},
								axisTick:{
					            	show:false,
					            },
								splitLine:{
									show:true,
									lineStyle:{
										color:'#8A96A0',
										opacity:.1
									}
								}
							},
						series : [
							{
								name:'销售费用',
								type:'line',
								symbol:'circle',
								symbolSize: dot3,
					            itemStyle: {
							        normal: {
										color:'#0092f6',
							            lineStyle: {
											color: "#0092f6",
											width:1
							            },
							            areaStyle: { 
											//color: '#94C9EC'
											color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [{
												offset: 0,
												color: 'rgba(7,44,90,0.3)'
											}, {
												offset: 1,
												color: 'rgba(0,146,246,0.9)'
											}]),
							            }
							        }
								},
								markPoint:{
									itemStyle:{
										normal:{
											color:'red'
										}
									}
								},
								data:arr3
							},
							{
								name:'管理费用',
								type:'line',
								symbol:'circle',
								symbolSize: dot2,
								
					            itemStyle: {
							        normal: {
							            color:'#00d4c7',
							            lineStyle: {
											color: "#00d4c7",
											width:1
							            },
							            areaStyle: { 
											//color: '#94C9EC'
											color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [{
												offset: 0,
												color: 'rgba(7,44,90,0.3)'
											}, {
												offset: 1,
												color: 'rgba(0,212,199,0.9)'
											}]),
							            }
							        }
								},
								data:arr2
							},
							{
								name:'财务费用',
								type:'line',
								symbol:'circle',
								symbolSize: dot1,
					            itemStyle: {
							        normal: {
							            color: '#aecb56',
							            lineStyle: {
											color: "#aecb56",
											width:1
							            },
							            areaStyle: { 
											//color: '#94C9EC'
											color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [{
												offset: 0,
												color: 'rgba(7,44,90,0.3)'
											}, {
												offset: 1,
												color: 'rgba(114,144,89,0.9)'
											}]),
							            }
							        }
								},
								data:arr1
							}
						]
					};
					myChart.setOption(option);
					window.onresize=function(){
				      myChart.resize();
				 }
			},
			
			// 数字加载动画
			numberGrow (ele,val) {
				val = this.formatMoney(val);
				val=Number(val);
				if(!val) {
					return;
				}
				let _this = this
				let step = 1;
				if(val>100) {
					step = (val * 10) / (_this.time * 1000);
				}else if(val<0) {
					if(val>-100) {
						step=-1;
					}else {
						step = (val * 10) / (_this.time * 1000);
					}
				}
				   
				   let current = 0
				   let start = 0
				   let t = setInterval(function () {
				    start += step;
					start = parseInt(start)
					if(val>0) {
						 if (start > val) {
						     clearInterval(t)
						     start = val
						     t = null
					    }
					}else {
						 if (start < val) {
						     clearInterval(t)
						     start = val
						     t = null
						console.log(start)
					    }
					}
				   
				    if (current === start) {
				     return
				    }
				     current = start

				    ele.innerHTML = currencys(current);
				   }, 10)
			    },
			// 收支占比仪表盘
			 getEcharts_szzb(allData) {
				let myChart = echarts.init(document.getElementById('echart_left_YVP')),centerHeight;
				let zzData = this.profit;
				var gauge_value = 40;
				if(allData[4].money>0&&allData[9].money>0) {
					centerHeight = allData[4].money>=allData[9].money?allData[4].money:allData[9].money;
				}else if(allData[4].money>=allData[9].money&&allData[4].money>0) {
					centerHeight = allData[4].money;
				}else if(allData[4].money<=allData[9].money&&allData[9].money>0){
					centerHeight = allData[9].money;
				}else {
					centerHeight = 100;
				}
				let option = {
				    backgroundColor: '#243145',
				    width: '100%',      // 画布大小
				    height: '100%',
				    center:["50%","50%"],
				    title: {
				        show: true,
				        x: "center",
				        bottom: 10,
				        text: '',
				        textStyle: {
				            fontWeight: 'normal',
				            fontSize: 12,
				            color: "#33ffff"
				        },
				    },
				    tooltip: {
				        show: true,
				        backgroundColor: '#243145',
				        textStyle: {
				            color: '#fff'
				        },
				        formatter: function(param) {
				        	if(param.data.name!="disabled") {
				               	return '<em style="color:#ffffff;">' + param.data.value + '元</em> '
		               		}else {
		               			return "";
		               		}
				           
				        }

				    },
				  
				    series: [{
				        name: 'zhizheng',
				        type: 'gauge',
				        z: 0,
				        radius: '250%',
				        startAngle: 180,
				        tooltip:{
				        	show:true,
				        	 textStyle: {
					            color: '#fff'
					        },
				        	backgroundColor:'#243145',
				        	formatter: function(param) {
					        	return zzData + '元';
					        }
				        },
				        endAngle: 0,
				        center: ["50%", "70%"], //整体的位置设置
				        axisLine: {
				            lineStyle: { // 属性lineStyle控制线条样式//指针颜色
				                color: [
				                    [1, '#CF4C4D']
				                ],
				                width: 0,
				            }
				        },
				        axisTick: {
				            show: false
				        },
				        splitLine: {
				            show: false
				        },
				        axisLabel: {
				            show: false
				        },
				        data: [this.pointerValue], //指针位置
				        pointer: {
				            show: true,
				            width: 5,
				            length: '15%'
				        },
				        detail: {
				            show: 0
				        }
				    },{
				        name: '内层圈',
				        type: 'gauge',
				        z: 6,
				        radius: '50%',
				        startAngle: 180,
				        endAngle: 0,
				        center: ["50%", "70%"], //整体的位置设置
				        axisLine: {
				            lineStyle: { // 属性lineStyle控制线条样式//控制外圈位置
				                color: [
				                    [1, {
				                        type: 'linear',
				                        x: 0,
				                        y: 0,
				                        x2: 0,
				                        y2: 1,
				                        colorStops: [{
				                            offset: 0,
				                            color: '#00D4FF' // 0% 处的颜色
				                        }, {
				                            offset: 1,
				                            color: '#0049E6' // 100% 处的颜色
				                        }],
				                        global: false // 缺省为 false
				                    }]
				                ],
				                width: 2,
				                opacity: 0.9, //控制外圈位置，颜色，宽度，透明度
				            }
				        },
				        axisTick: {
				            show: false
				        },
				        splitLine: {
				            show: false
				        },
				        axisLabel: {
		                	show: false,
				        },
				        pointer: {
				            show: false
				        },
				        data: [{
				            show: true,
				            value: '0.9'
				        }],
				        detail: {
				            show: 0
				        }
				    },{
				        name: '外层盘',
				        type: 'gauge',
				        z: 6,
				        radius: '120%',
				        startAngle: 180,
				        endAngle: 0,
				        center: ["50%", "70%"], //整体的位置设置
				        axisLine: {
				            lineStyle: { // 属性lineStyle控制线条样式//控制外圈位置
				                color: [
				                    [1, {
				                        type: 'linear',
				                        x: 0,
				                        y: 0,
				                        x2: 0,
				                        y2: 1,
				                        colorStops: [{
				                            offset: 0,
				                            color: '#00D4FF' // 0% 处的颜色
				                        }, {
				                            offset: 1,
				                            color: '#0049E6' // 100% 处的颜色
				                        }],
				                        global: false // 缺省为 false
				                    }]
				                ],
				                width: 15,
				                opacity: 0.9, //控制外圈位置，颜色，宽度，透明度
				            }
				        },
				        axisTick: {
				            show: false
				        },
				        splitLine: {
				            show: false
				        },
				        axisLabel: {
		                show: true,
			                fontSize: 12,
			                fontWeight: 'bold',
			                color:'#3EC2FF',
			                distance: -90,
			                formatter:function(val){
			                    var ll = '';
			                    switch (val) {
			                        case 0:
			                           ll='主营业务';
			                            break;
			                         case 10:
			                               ll='其他业务';
			                            break;
			                             case 20:
			                                  ll='投资收益';
			                            break;
			                             case 30:
			                                   ll='营业外收入';
			                            break;
			                             case 70:
			                                  ll='成本支出';
			                            break;
			                            case 80:
			                                  ll='费用支出';
			                            break;
			                            case 90:
			                                  ll='应交税金';
			                            break;
			                            case 100:
			                                  ll='其他支出';
			                            break;
			                        default:
			                            break;
			                    }
			                    return ll;
			                }
			            },
				        pointer: {
				            show: false
				        },
				        data: [{
				            show: true,
				            value: '0.9'
				        }],
				        detail: {
				            show: 0
				        }
				    }, {
				        "name": "扇形图",
				        "type": "pie",
				        "radius": ['50%',' 80%' ],
				        "avoidLabelOverlap": false,
				        "hoverAnimation":false,
				        "startAngle": 180,
				        "center": [ "50%","70%"],
				        "roseType": "area",
				        "label": {
				            "normal": {
				               "show": true,
				               "formatter": function(val){
				               		if(val.data.name!="disabled"&&val.data.name) {
				               			return val.data.percentage+'%';
				               		}else {
				               			return "";
				               		}
				               },
				               "color":'#3EC2FF',
				            },
				            "emphasis": {
				                "show":true
				            }
				        },
				        "labelLine": {
				            "normal": {
				                "show": false,
				                "smooth": false,
				                "length": 0,
				                "length2": 0
				            },
				            "emphasis": {
				                "show": false
				            }
				        },
				        
				        itemStyle:{
						     normal: {
						         borderWidth: '10%', 
						        borderColor: '#363D4A',
						      }
						},
				        "data": [{
				                "percentage": allData[0].percentage,
				                "value": allData[0].money,
				                "name": "主营业务",
				                "itemStyle": {
				                    "normal": {
				                        "color": new echarts.graphic.LinearGradient(0, 0, 1, 1, [{
				                            offset: 0,
				                            color: '#00A6FF'
				                        }, {
				                            offset: 1,
				                            color: '#003D9D'
				                        }], false),
				                    }
				                }
				            },
				            {
				                "percentage": allData[1].percentage,
				                 "value": allData[1].money,
				                "name": "其他业务",
				                "itemStyle": {
				                    "normal": {
				                        "color": new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
				                            offset: 0,
				                            color: '#00D4FF'
				                        }, {
				                            offset: 1,
				                            color: '#0049E6'
				                        }], false) 
				                    }
				                }
				            },
				            {
				                "percentage": allData[2].percentage,
				                "value": allData[2].money,
				                "name": "投资收益",
				                "itemStyle": {
				                    "normal": {
				                        "color":  new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
				                            offset: 0,
				                            color: '#00D4FF'
				                        }, {
				                            offset: 1,
				                            color: '#0049E6'
				                        }], false) 
				                    }
				                }
				            },
				            {
				                "percentage": allData[3].percentage,
				                 "value": allData[3].money,
				                "name": "营业外收入",
				                "itemStyle": {
				                    "normal": {
				                        "color":  new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
				                            offset: 0,
				                            color: '#1CC1FF'
				                        }, {
				                            offset: 1,
				                            color: '#0142AA'
				                        }], false) 
				                    }
				                }
				            }, {
				                "value": centerHeight,
				                "name": "disabled",
				                "itemStyle": {
				                    "normal": {
				                        "color":  new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
				                            offset: 0,
				                            color: '#21738f'
				                        }, {
				                            offset: 1,
				                            color: '#184c75'
				                        }], false) 
				                    }
				                }
				            },
				            {
				                "percentage":  allData[5].percentage,
				                 "value": allData[5].money,
				                "name": "本期成本",
				                "itemStyle": {
				                    "normal": {
				                        "color":  new echarts.graphic.LinearGradient(1, 0, 0, 0, [{
				                            offset: 0,
				                            color: '#1CFFFE'
				                        }, {
				                            offset: 1,
				                            color: '#139DE5'
				                        }], false) 
				                    }
				                }
				            },
				            {
				                "percentage": allData[6].percentage,
				                 "value": allData[6].money,
				                "name": "本期费用",
				                "itemStyle": {
				                    "normal": {
				                        "color": new echarts.graphic.LinearGradient(1, 0, 0, 0, [{
				                            offset: 0,
				                            color: '#1CFFFE'
				                        }, {
				                            offset: 1,
				                            color: '#139DE5'
				                        }], false) 
				                    }
				                }
				            },
				            {
				                "percentage":  allData[7].percentage,
				                 "value": allData[7].money,
				                "name": "本期税金",
				                "itemStyle": {
				                    "normal": {
				                        "color":  new echarts.graphic.LinearGradient(1, 0, 0, 0, [{
				                            offset: 0,
				                            color: '#1CFFFE'
				                        }, {
				                            offset: 1,
				                            color: '#139DE5'
				                        }], false) 
				                    }
				                }
				            },
				            {
				                "percentage":  allData[8].percentage,
				                 "value": allData[8].money,
				                "name": "其他支出",
				                "itemStyle": {
				                    "normal": {
				                        "color":  new echarts.graphic.LinearGradient(1, 0, 0, 0, [{
				                            offset: 0,
				                            color: '#1CFFFE'
				                        }, {
				                            offset: 1,
				                            color: '#139DE5'
				                        }], false) 
				                    }
				                }
				            },
				            {
				                "value": 0,
				                "name": "",
				                "itemStyle": {
				                    "normal": {

				                        "label": {
				                            "show": false,
				                        },
				                        "labelLine": {
				                            "show": false
				                        }
				                    }
				                }
				            },
				            {
				                "value": 0,
				                "name": "",
				                "itemStyle": {
				                    "normal": {
				                        "label": {
				                            "show": false
				                        },
				                        "labelLine": {
				                            "show": false
				                        }
				                    }
				                }
				            },
				            {
				                "value": 0,
				                "name": "",
				                "itemStyle": {
				                    "normal": {
				                        "label": {
				                            "show": false
				                        },
				                        "labelLine": {
				                            "show": false
				                        }
				                    }
				                }
				            },
				            {
				                "value": 0,
				                "name": "",
				                "itemStyle": {
				                    "normal": {
				                        "label": {
				                            "show": false
				                        },
				                        "labelLine": {
				                            "show": false
				                        }
				                    }
				                }
				            },
				            {
				                "value": 0,
				                "name": "",
				                "itemStyle": {
				                    "normal": {
				                        "label": {
				                            "show": false
				                        },
				                        "labelLine": {
				                            "show": false
				                        }
				                    }
				                }
				            },
				            {
				                "value": 0,
				                "name": "",
				                "itemStyle": {
				                    "normal": {
				                        "label": {
				                            "show": false
				                        },
				                        "labelLine": {
				                            "show": false
				                        }
				                    }
				                }
				            },
				            {
				                "value": 0,
				                "name": "",
				                "itemStyle": {
				                    "normal": {
				                        "label": {
				                            "show": false
				                        },
				                        "labelLine": {
				                            "show": false
				                        }
				                    }
				                }
				            },
				            {
				                "value": 0,
				                "name": "",
				                "itemStyle": {
				                    "normal": {
				                        "label": {
				                            "show": false
				                        },
				                        "labelLine": {
				                            "show": false
				                        }
				                    }
				                }
				            },
				            {
				                "value": 0,
				                "name": "",
				                "itemStyle": {
				                    "normal": {
				                        "label": {
				                            "show": false
				                        },
				                        "labelLine": {
				                            "show": false
				                        }
				                    }
				                }
				            }]
				    }]
				};
				myChart.setOption(option);
				window.onresize=function(){
				      myChart.resize();
				 }
			},
			// 资产负债增长趋势图
			getEcharts_zzqst() {

				let myChart = echarts.init(document.getElementById('echart_zzqst'));
				let dataIPSxAxis = this.assetsTotalLineData.month;
				let dataIPS1 = this.assetsTotalLineData.money;
				let daveData,dot;
				if(dataIPS1.length) {
					daveData = dataIPS1.filter(i=>{
						return i || i==0
					})
				}
				dot = daveData.length==1?8:0.01;
				 let option = {
				       title : {
				        text: '',
				        subtext: '',
				        textStyle:{
				            color:"#fff"
				        }
				    },
				     backgroundColor:"",
				     tooltip: {
				         trigger: 'axis',
				         formatter: function(val){
				         	return val[0].axisValue+ "月：" + currencys(val[0].value) + "  元";
				         },
				         // axisPointer: {
				         //     type: 'cross',
				         //     label: {
				         //         backgroundColor: '#6a7985',
				         //     },
				         // }
				     },
				     color: ["#4cd5ce"],
				      
				     toolbox: {
				         // feature: {
				         //     saveAsImage: {}
				         // }
				     },
				     grid: {
				        left: '2%',
				        right: '2%',
				        top:'10%',
				        bottom: '0%',
				         containLabel: true
				     },
				     xAxis: [{
				         type: 'category',
				         boundaryGap: false,
				         data: dataIPSxAxis,
				         show:true,
				         axisLabel: {
				             show: true,
				             textStyle: {
				                 color: '#8A96A0',
				                 fontSize: 12,
				             },
				             formatter: function(value) {
				                 var ret = ""; //拼接加\n返回的类目项
				                 var maxLength = 5; //每项显示文字个数
				                 var valLength = value.length; //X轴类目项的文字个数
				                 var rowN = Math.ceil(valLength / maxLength); //类目项需要换行的行数
				                 if (rowN > 1) //如果类目项的文字大于3,
				                 {
				                     for (var i = 0; i < rowN; i++) {
				                         var temp = ""; //每次截取的字符串
				                         var start = i * maxLength; //开始截取的位置
				                         var end = start + maxLength; //结束截取的位置
				                         //这里也可以加一个是否是最后一行的判断，但是不加也没有影响，那就不加吧
				                         temp = value.substring(start, end) + "\n";
				                         ret += temp; //凭借最终的字符串
				                     }
				                     return ret;
				                 } else {
				                     return value;
				                 }
				             },
				         },
				         axisLine: {
				         	show: true,
				            lineStyle: {
				                 color: '#3b424e',
				                 opacity:.8
				             }
				         },
				          splitLine:{
			                show:false,
			                lineStyle:{
			                    type:'dashed',
			                    opacity: 0.05,
			                }
			                
			            },
				     }],
				     yAxis: [{
				         type: 'value',
				         show: false,
				         axisLine: {
				             onZero: false,
				             lineStyle: {
				                 color: '#3b424e',
				                 width: 2, //这里是为了突出显示加上的
				                 opacity: 0.1,
				             }
				         },
				         
				         axisLabel: {
				             formatter: function(val) {

				                 return 1;
				             },
				             show: false,
				             textStyle: {
				                 color: '#8A96A0' //字体颜色
				             }
				         },
				          splitLine:{
			                show:false,
			                lineStyle:{
			                    type:'dashed',
			                	opacity: 0.05,
			                    
			                }
			                
			            },
				     }],
				     series: [
				   		 {
				             name: '收支趋势',
				             type: 'line',
				             smooth: true,
				             //  symbol: "none", //去掉折线点
				             stack: 100,
				             itemStyle: {
				             	//color: ["#363D4A", "#798BAC"],
				                 normal: { //颜色渐变函数 前四个参数分别表示四个位置依次为左、下、右、上
				                     color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
				                         offset: 0,
				                         color: '#35517c' // 0% 处的颜色
				                     }, {
				                         offset: 0.5,
				                         color: '#35517c' // 100% 处的颜色
				                     }, {
				                         offset: 1,
				                         color: '#243145' // 100% 处的颜色
				                     }]), //背景渐变色
				                     lineStyle: { // 系列级个性化折线样式
				                         width: 5,
				                         type: 'solid',
				                         color: "#1CFFFE"
				                     }
				                 },
				                 emphasis: {
				                     color: '#fff',
				                     lineStyle: { // 系列级个性化折线样式
				                         width: 5,
				                         type: 'dotted',
				                         color: "#268aff" //折线的颜色
				                     }
				                 }
				             }, 
				             //线条样式
				             symbolSize:dot, //折线点的大小
				             areaStyle: {
				                 normal: {}
				             },
				             data: dataIPS1,
				         },
				     ]
				 };
				myChart.setOption(option);
				window.onresize=function(){
				      myChart.resize();
				 }
			},
			// 收支趋势
			getEcharts_szqs(allData) {
				let myChart = echarts.init(document.getElementById('Proportion_SZQS'));
				let dataIPSxAxis = allData.month;
				let dataIPS1 = allData.out;
				let dataIPS2 = allData.income;
				let daveData1,dot1,daveData2,dot2;
				if(dataIPS1.length) {
					daveData1 = dataIPS1.filter(i=>{
						return i || i==0;
					})
				}
				dot1 = daveData1.length==1?8:0.01;
				if(dataIPS2.length) {
					daveData2 = dataIPS2.filter(i=>{
						return i || i==0;
					})
				}
				dot2 = daveData2.length==1?8:0.01;
				 let option = {
				       title : {
				        text: '',
				        subtext: '',
				        textStyle:{
				            color:"#fff"
				        }
				    },
				     backgroundColor:"",
				     tooltip: {
				         trigger: 'axis',
				         formatter:function(params) {
						    return '<p style="color:#969EAC;font-size:12px">' + params[0].seriesName + '</p>'+'<p style="color:#B21C00;font-size:14px;font-weight:bold;">' + currencys(params[0].value) + '</p>'+ '<p style="color:#969EAC;font-size:12px;margin-top:12px;">' + params[1].seriesName + '</p>'+'<p style="color:#269D7B;font-size:14px;font-weight:bold;">' + currencys(params[1].value) + '</p>'
						},
				         
				     },
				     toolbox: {
				         // feature: {
				         //     saveAsImage: {}
				         // }
				     },
				     grid: {
				        left: '5%',
				        right: '5%',
				        top:'10%',
				        bottom: '5%',
				        containLabel: true
				     },
				     xAxis: [{
				         type: 'category',
				         boundaryGap: false,
				         data: dataIPSxAxis,
				         show:true,
				         axisLabel: {
				             show: true,
				             textStyle: {
				                 color: '#8A96A0',
				                 fontSize: 12,
				             },
				             formatter: function(value) {
				                return value;
				             },
				         },
				         axisLine: {
				             lineStyle: {
				                 color: '#3b424e',
				             }
				         },
				          splitLine:{
			                show:false,
			                lineStyle:{
			                    type:'dashed',
			                    opacity: 0.05,
			                }
			                
			            },
				     }],
				     yAxis: [{
				         type: 'value',
				         show: false,
				         axisLine: {
				             onZero: false,
				             lineStyle: {
				                 color: '#3b424e',
				                 width: 2, //这里是为了突出显示加上的
				                 opacity: 0.1,
				             }
				         },
				         
				         axisLabel: {
				             formatter: function(val) {
				                 return val + '';
				             },
				             show: true,
				             textStyle: {
				                 color: '#8A96A0' //字体颜色
				             }
				         },
				          splitLine:{
			                show:true,
			                lineStyle:{
			                    type:'dashed',
			                	opacity: 0.05,
			                    
			                }
			                
			            },
				     }],
				     series: [
				     {
				             name: '收入',
				             type: 'line',
				             smooth: true,
				             //  symbol: "none", //去掉折线点
				             stack: '收入',
				             itemStyle: {
				             	//color: ["#363D4A", "#798BAC"],
				                 normal: { //颜色渐变函数 前四个参数分别表示四个位置依次为左、下、右、上
				                     color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
				                         offset: 0,
				                         color: '#35517c' // 0% 处的颜色
				                     }, {
				                         offset: 0.5,
				                         color: '#35517c' // 100% 处的颜色
				                     }, {
				                         offset: 1,
				                         color: '#363f4c' // 100% 处的颜色
				                     }]), //背景渐变色
				                     lineStyle: { // 系列级个性化折线样式
				                         width: 5,
				                         type: 'solid',
				                         color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
						                         offset: 0,
						                         color: '#1CFFFE ' // 0% 处的颜色
						                     }, {
						                         offset: 0.5,
						                         color: '#139DE5' // 100% 处的颜色
						                     }, {
						                         offset: 1,
						                         color: '#1CFFFE ' // 100% 处的颜色
						                     }]), //背景渐变色
				                     }
				                 },
				                 emphasis: {
				                     color: '#fff',
				                     lineStyle: { // 系列级个性化折线样式
				                         width: 5,
				                         type: 'dotted',
				                         color: "#268aff" //折线的颜色
				                     }
				                 }
				             }, 
				             //线条样式
				             symbolSize: dot2, //折线点的大小
				             areaStyle: {
				                 normal: {}
				             },
				             data: dataIPS2,
				         }, {
				             name: '支出',
				             type: 'line',
				             smooth: true,
				             //  symbol: "none", //去掉折线点
				             stack: '支出',
				             itemStyle: {
				             	//color: ["#363D4A", "#798BAC"],
				                 normal: { //颜色渐变函数 前四个参数分别表示四个位置依次为左、下、右、上
				                     color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
				                         offset: 0,
				                         color: '#35517c' // 0% 处的颜色
				                     }, {
				                         offset: 0.5,
				                         color: '#35517c' // 100% 处的颜色
				                     }, {
				                         offset: 1,
				                         color: '#363f4c' // 100% 处的颜色
				                     }]), //背景渐变色
				                     lineStyle: { // 系列级个性化折线样式
				                         width: 5,
				                         type: 'solid',
				                         color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
					                         offset: 0,
					                         color: '#1CD1A1' // 0% 处的颜色
					                     }, {
					                         offset: 0.5,
					                         color: '#3CEACF' // 100% 处的颜色
					                     }, {
					                         offset: 1,
					                         color: '#1CD1A1' // 100% 处的颜色
					                     }]), //背景渐变色
				                     }
				                 },
				                 emphasis: {
				                     color: '#fff',
				                     lineStyle: { // 系列级个性化折线样式
				                         width: 5,
				                         type: 'dotted',
				                         color: "#268aff" //折线的颜色
				                     }
				                 },
				             }, 
				             //线条样式
				             symbolSize: dot2, //折线点的大小
				             areaStyle: {
				                 normal: {}
				             },
				             data: dataIPS1,
				         },
				     ]
				 };
				myChart.setOption(option);
				window.onresize=function(){
				      myChart.resize();
				 }
			},
			// 收支盈亏状况
			getEcharts_szyk() {
				let myChart = echarts.init(document.getElementById('Proportion_SZYK'));
				let zzData = this.profit;
				let option = {
			    backgroundColor: '',
			    tooltip:{
			    	show: true,
			    },
				series: [
				    {
				        name: '指针',
				        type: 'gauge',
				        z: 0,
				        radius: '50%',
				        startAngle: 180,
				        endAngle: 0,
				        center: ["50%", "95%"], //整体的位置设置
				         tooltip:{
				        	show:true,
				        	 textStyle: {
					            color: '#fff'
					        },
				        	backgroundColor:'#243145',
				        	formatter: function(param) {
					        	return zzData + '元';
					        }
				        },
				        axisLine: {
				            lineStyle: { // 属性lineStyle控制线条样式//指针颜色
				                color: [
				                    [1, '#CF4C4D']
				                ],
				                width: 0,
				            }
				        },
				        axisTick: {
				            show: false
				        },
				        splitLine: {
				            show: false
				        },

				        axisLabel: {
				           show: false,
				        },
				        data: [this.pointerValue], //指针位置
				        pointer: {
				            show: true,
				            width: 5,
				            length: '150%'
				        },
				        detail: {
				            show: 0
				        }
				    },{
				        name: '外层盘',
				        type: 'gauge',
				        z: 6,
				        radius: '180%',
				        startAngle: 180,
				        endAngle: 0,
				        center: ["50%", "95%"], //整体的位置设置
				        axisLine: {
				            lineStyle: { // 属性lineStyle控制线条样式//控制外圈位置
				                color: [
				                    [1, {
				                        type: 'linear',
				                        x: 0,
				                        y: 0,
				                        x2: 0,
				                        y2: 1,
				                        colorStops: [{
				                            offset: 0,
				                            color: '#1CFFFE' // 0% 处的颜色
				                        }, {
				                            offset: 1,
				                            color: '#1CFFFE' // 100% 处的颜色
				                        }],
				                        global: false // 缺省为 false
				                    }]
				                ],
				                width: 5,
				                opacity: 0.9, //控制外圈位置，颜色，宽度，透明度
				            }
				        },
				        axisTick: {
				            show: false
				        },
				        splitLine: {
				            show: false
				        },
				       axisLabel: {
		                show: true,
		                fontSize: 12,
		                position: 'absolute',
		                fontWeight: 'bold',
		                color:'#fff',
		                distance: -60,
		                formatter:function(val){
				                    var lll = '';
				                    switch (val) {
				                        case 0:
				                           lll='收入';
				                            break;
				                        case 100:
				                            lll='支出';
				                            break;
				                        default:
				                            break;
				                    }
				                    return lll;
				                }
				            },
				        pointer: {
				            show: false
				        },
				        data: [{
				            show: true,
				            value: '0.9'
				        }],
				        detail: {
				            show: 0
				        }
				    },{
						type: 'gauge',
						name: '业务指标',
						radius:'150%',
						startAngle:'0',
						endAngle:'80',
						splitNumber:'8',
						center: ["50%", "95%"], //整体的位置设置
						pointer:{
							show:false
						},
						title:{
						    show:false
						},
						detail: {
			    			show:false
						},
						data: [{value: 95, name: '完成率'}],
						axisLine:{
							lineStyle: { 
								width: 20,
								opacity: 0
							}
						},
						axisTick: {
							show: false
						},
						splitLine: {
							show: true,
							length:12,
							lineStyle: {
								color: '#F9B308',
								width: 3,
								type: 'solid',
							},
						},
						 axisLabel: {
			                show: true,
			                fontSize: 12,
			                color:'#fff',
			                distance: 10,
			                formatter:function(val){
			                    var llll = '';
			                    switch (val) {
			                        case 0:
			                           llll='100%';
			                            break;
			                        default:
			                            break;
			                    }
			                    return llll;
			                }
			            },
					},	{
						type: 'gauge',
						name: '业务指标',
						radius:'150%',
						startAngle:'100',
						endAngle:'180',
						splitNumber:'8',
						center: ["50%", "95%"], //整体的位置设置
						pointer:{
							show:false
						},
						title:{
						    show:false
						},
						detail: {
			    			show:false
						},
						data: [{value: 95, name: '完成率'}],
						axisLine:{
							lineStyle: { 
								width: 20,
								opacity: 0
							}
						},
						axisTick: {
							show: false
						},
						splitLine: {
							show: true,
							length:12,
							lineStyle: {
								color: '#328CFF',
								width: 3,
								type: 'solid',
							},
						},
						 axisLabel: {
			                show: true,
			                fontSize: 12,
			                color:'#fff',
			                distance: 10,
			                formatter:function(val){
			                    var llll = '';
			                    switch (val) {
			                        case 100:
			                           llll='100%';
			                            break;
			                        default:
			                            break;
			                    }
			                    return llll;
			                }
			            },
					},{
						type: 'gauge',
						name: '业务指标',
						radius:'67%',
						startAngle:'90',
						endAngle:'100',
						splitNumber:'0',
						center: ["50%", "53%"], //整体的位置设置
						pointer:{
							show:false
						},
						title:{
						    show:false
						},
						detail: {
			    			show:false
						},
						data: [{value: 95, name: '完成率'}],
						axisLine:{
							lineStyle: { 
								width: 20,
								opacity: 0
							}
						},
						axisTick: {
							show: false
						},
						splitLine: {
							show: true,
							length:12,
							lineStyle: {
								color: '#fff',
								width: 3,
								type: 'solid',
							},
						},
						axisLabel: {
							show: true,
			                fontSize: 12,
			                color:'#fff',
			                distance: 10,
			                formatter:function(val){
			                   return "0";
			                }
						}
					},
				]
			};
				myChart.setOption(option);
				window.onresize=function(){
				      myChart.resize();
				 }
			}
		},
		watch: {
			super_messages(val) {
				this.getMaxPeriodInfo();
			}
		}
	}
</script>
<style lang='less' scoped>
	@import '../assets/css/reportDesk.less';
</style>


// WEBPACK FOOTER //
// src/pages/dashboard.vue